export const ShimmerUI = () => (
  <div className="animate-pulse max-w-container mx-auto px-4">
    {/* Banner shimmer */}
    <div className="w-full h-[400px] bg-gray-200 rounded-lg mb-8"></div>

    {/* Products grid shimmer */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {[1, 2, 3, 4].map((item) => (
        <div key={item} className="space-y-4">
          <div className="bg-gray-200 h-[200px] rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
      ))}
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {[1, 2, 3, 4].map((item) => (
        <div key={item} className="space-y-4">
          <div className="bg-gray-200 h-[200px] rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
      ))}
    </div>
  </div>
);
export const ShopShimmerUI = () => (
  <div className="animate-pulse max-w-container mx-auto px-4">
    {/* Banner shimmer */}
 
    {/* Products grid shimmer */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {[1, 2, 3, 4].map((item) => (
        <div key={item} className="space-y-4">
          <div className="bg-gray-200 h-[200px] rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
      ))}
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {[1, 2, 3, 4].map((item) => (
        <div key={item} className="space-y-4">
          <div className="bg-gray-200 h-[200px] rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
      ))}
    </div>
  </div>
);
export const SmallShimmerUI = () => (
  <div className="animate-pulse max-w-container mx-auto px-4">
    {/* Banner shimmer */}
    <div className="w-full h-[10px] bg-gray-200 rounded-lg mb-8"></div>
  </div>
);
